import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from "@angular/router";
import { Observable } from "rxjs";
import { AuthservicesService } from '../services/authservices.service';

@Injectable({
  providedIn: "root"
})
export class DashGuardGuard implements CanActivate {
  record
  completeReg
  constructor(
    private router: Router,
    private authenticationService: AuthservicesService
  ) {
    this.record = JSON.parse(localStorage.getItem('requestToken'));
    this.completeReg = JSON.parse(localStorage.getItem('completeReg'));
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const currentUser = this.authenticationService.currentUserValue;
    if (this.record) {
      return true
    }
    if (currentUser) {
      return true;
    }

    // not logged in so redirect to login page with the return url
    this.router.navigate(["/user-registration/basic-info"]);
    return false;
  }
}
// canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):boolean {
//   if (localStorage.getItem('isLoggedin')) {


//       return true;
//   }


//   this.router.navigate(['/login']);
//   return false;
// }